import { createFileRoute } from "@tanstack/react-router";
import { TerminBuchen } from "@/pages/client/TerminBuchen";

/** „Termin buchen" im Kundenbereich (13.09.2026) — wie Calendly, nur eingeloggt. */
export const Route = createFileRoute("/_angemeldet/buchen")({
	component: TerminBuchen,
});
